import { useTranslation } from 'react-i18next';

export default function SeoContent() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-20 bg-background-100 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20arrangement%20of%20elegant%20minimalist%20desk%20accessories%20and%20fashion%20items%20including%20a%20leather%20notebook%20and%20silk%20scarf%20on%20warm%20textured%20cream%20paper%20background%2C%20soft%20morning%20light%20creating%20long%20delicate%20shadows%2C%20neutral%20earth%20tone%20color%20palette%20with%20terracotta%20and%20sand%20accents%2C%20Scandinavian%20minimalist%20lifestyle%20photography%2C%20airy%20fresh%20composition%2C%20editorial%20blog%20aesthetic&width=1200&height=800&seq=yoybuy-content-v2-2026&orientation=landscape"
          alt="Yoybuy Sheet content background"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-8 text-center">
          {t('seo_section_title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-white/80 backdrop-blur-sm border border-background-200 rounded-xl p-6 md:p-7">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
              <i className="ri-bar-chart-line w-5 h-5 flex items-center justify-center"></i>
            </div>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              {t('seo_section_text_1')}
            </p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm border border-background-200 rounded-xl p-6 md:p-7">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
              <i className="ri-refresh-line w-5 h-5 flex items-center justify-center"></i>
            </div>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              {t('seo_section_text_2')}
            </p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm border border-background-200 rounded-xl p-6 md:p-7">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 mb-4">
              <i className="ri-guide-line w-5 h-5 flex items-center justify-center"></i>
            </div>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              {t('seo_section_text_3')}
            </p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm border border-background-200 rounded-xl p-6 md:p-7">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
              <i className="ri-money-dollar-circle-line w-5 h-5 flex items-center justify-center"></i>
            </div>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              {t('seo_section_text_4')}
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-300 text-sm cursor-pointer"
          >
            <i className="ri-file-excel-2-line w-5 h-5 flex items-center justify-center"></i>
            {t('btn_yoybuy_sheet')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-foreground-900 hover:bg-foreground-800 text-white font-semibold rounded-full transition-all duration-300 text-sm cursor-pointer"
          >
            <i className="ri-shopping-cart-line w-5 h-5 flex items-center justify-center"></i>
            {t('btn_buy_now')}
          </a>
        </div>
      </div>
    </section>
  );
}